// extracted by mini-css-extract-plugin
export default {"previousPlaces":"styles_previousPlaces__qGYVr","title":"styles_title__fy+MD","emptyPage":"styles_emptyPage__Szqm5"};